import { SystemEntity } from '@erp/shared-types';
import { Badge } from '@/components/ui/badge';
import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent,
} from '@/components/ui/hover-card';
import { cn } from '@/lib/utils';
import { EnvelopeIcon } from '@phosphor-icons/react';
import { SystemEntityPreview } from '../preview-ui';
import { useOutboundEmail } from '@/api/rpc/hooks/communications/useOutboundEmail';

interface OutboundEmailInlineProps {
  entityType: SystemEntity; // required by registry; type is OUTBOUND_EMAIL
  entityId: string;
  className?: string;
}

export function OutboundEmailInline({
  entityId,
  className,
}: OutboundEmailInlineProps) {
  const { outboundEmail, isLoading } = useOutboundEmail(entityId);

  const displayName = isLoading
    ? 'Loading...'
    : outboundEmail
      ? outboundEmail.subject || 'Remittance Email'
      : 'Email';

  return (
    <HoverCard openDelay={200} closeDelay={100}>
      <HoverCardTrigger asChild>
        <div className="inline-block max-w-full">
          <Badge
            variant="outline"
            className={cn('gap-1.5 cursor-pointer max-w-full', className)}
          >
            <EnvelopeIcon className="size-3 shrink-0" />
            <span className="truncate">{displayName}</span>
          </Badge>
        </div>
      </HoverCardTrigger>
      <HoverCardContent
        className="w-auto p-0 pointer-events-auto"
        align="start"
        side="bottom"
        sideOffset={2}
        onPointerEnter={(e) => e.stopPropagation()}
        onPointerLeave={(e) => e.stopPropagation()}
      >
        <SystemEntityPreview
          entityType={SystemEntity.OUTBOUND_EMAIL}
          entityId={entityId}
        />
      </HoverCardContent>
    </HoverCard>
  );
}
